module.exports = __webpack_public_path__ + "static/media/type-2.ad14dfd3.svg";